var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 83",
    style: {
      enableBackground: "new 0 0 80 83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0D4CD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    transform: "translate(-311 -2353)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    className: "st0",
    cx: 351,
    cy: 2396,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_17",
    transform: "translate(-425.987 1793.292)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M777.2,635.7c-2.6,0-4.7-2.1-4.7-4.7v-28.4c-4.4-1-8.3-3.4-11.3-6.8c-1.6-1.9-2.8-4-3.7-6.3 c-0.9-2.4-1.3-4.9-1.3-7.4c0-2.8,0.6-5.6,1.7-8.2c1.1-2.5,2.6-4.7,4.5-6.7s4.2-3.4,6.7-4.5c2.6-1.1,5.3-1.7,8.2-1.7 c2.8,0,5.6,0.6,8.2,1.7c2.5,1.1,4.7,2.6,6.7,4.5c1.9,1.9,3.4,4.2,4.5,6.7c1.1,2.6,1.7,5.3,1.7,8.2c0,2.6-0.5,5-1.3,7.4 c-0.9,2.3-2.1,4.4-3.7,6.3c-2.9,3.4-6.9,5.8-11.3,6.8v28.4C781.8,633.7,779.7,635.7,777.2,635.7z M777.2,569.1 c-3.5,0-6.8,1.4-9.3,3.8c-2.5,2.5-3.8,5.8-3.8,9.3c0,3.5,1.4,6.8,3.8,9.3c2.5,2.5,5.8,3.8,9.3,3.8c3.5,0,6.8-1.4,9.3-3.8 c2.5-2.5,3.8-5.8,3.8-9.3c0-3.5-1.4-6.8-3.8-9.3C783.9,570.5,780.7,569.1,777.2,569.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.2,562.7c-10.8,0-19.5,8.7-19.5,19.5c0,9.7,7.1,17.7,16.3,19.2c0,0,0,0.1,0,0.1v29.5c0,1.7,1.4,3.2,3.2,3.2 c1.7,0,3.2-1.4,3.2-3.2v-29.5c0,0,0-0.1,0-0.1c9.3-1.5,16.3-9.5,16.3-19.2C796.6,571.4,787.9,562.7,777.2,562.7 M777.2,596.8 c-8.1,0-14.6-6.5-14.6-14.6s6.5-14.6,14.6-14.6c8.1,0,14.6,6.5,14.6,14.6S785.2,596.8,777.2,596.8 M777.2,559.7c3,0,6,0.6,8.8,1.8 c2.7,1.1,5.1,2.8,7.1,4.8c2.1,2.1,3.7,4.5,4.8,7.1c1.2,2.8,1.8,5.7,1.8,8.8c0,2.7-0.5,5.4-1.4,7.9c-0.9,2.5-2.3,4.7-4,6.7 c-2.9,3.4-6.7,5.8-10.9,7v27.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2v-27.3c-4.2-1.2-8-3.6-10.9-7c-1.7-2-3-4.2-4-6.7 c-1-2.5-1.4-5.2-1.4-7.9c0-3,0.6-6,1.8-8.8c1.1-2.7,2.8-5.1,4.8-7.1c2.1-2.1,4.5-3.7,7.1-4.8C771.2,560.3,774.1,559.7,777.2,559.7 z M777.2,593.8c3.1,0,6-1.2,8.2-3.4s3.4-5.1,3.4-8.2s-1.2-6-3.4-8.2c-2.2-2.2-5.1-3.4-8.2-3.4c-3.1,0-6,1.2-8.2,3.4 c-2.2,2.2-3.4,5.1-3.4,8.2s1.2,6,3.4,8.2S774.1,593.8,777.2,593.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.24420120387aab3a75bfe2a07df9a21f.svg";
export { ForwardRef as ReactComponent };